import { useMicVAD } from '@ricky0123/vad-react'
import  logger  from './Logger';
import { EventDispatcher } from 'three';

export const EVENT_INITIALIZED = "AudioService#EVENT_INITIALIZED";
export const EVENT_VOICEDSUBMIT = "AudioService#EVENT_VOICEDSUBMIT";

class AudioServiceEvent extends Event{
    constructor(type, message) {
        super(type)
        this.message = message;
    }
}

class AudioService extends EventTarget {

    async initialize() {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        try {
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 16000 });
            this.mainMediaStreamSource = this.audioContext.createMediaStreamSource(stream);
        } catch {
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
            this.mainMediaStreamSource = this.audioContext.createMediaStreamSource(stream);
        }
        this.dispatchEvent(new Event(EVENT_INITIALIZED));
        logger.log(`[AudioService] Initialized`);
        this.initializeRecorder();
        this.setupListeners();
        this.clickAudioBuffer = await this.setupAudioPlayback();
        return this;
    }

    async setupAudioPlayback() {
        // Fetch and decode the WAV file
        fetch("click.wav")
          .then(response => response.arrayBuffer())
          .then(arrayBuffer => this.audioContext.decodeAudioData(arrayBuffer))
          .then(buffer => {
            return buffer;
            // showQosMessage("Audio preloaded and ready to play!");
          });
    }
    
    playBlip() {
        if (this.clickAudioBuffer) {
          try {
            const source = this.audioContext.createBufferSource();
            source.buffer = this.clickAudioBuffer;
            source.connect(this.audioContext.destination);
            source.start();
  
          } catch (e) {
            console.error(e.message);
          }
        }
      }
  
    setupListeners() {
        document.addEventListener("pointerup", (event) => {
            if (!this.playedBlip) {
                this.playBlip();
                this.playedBlip = true;
            }
        });
    }
    initializeRecorder(source) {
        if(this.voiceRecorder) {
            console.log(`[AudioService] Recorder Already Initialized`)
            return this.voiceRecorder;
        }
        const sourceNode = source ?? this.mainMediaStreamSource;
        const config = {
            numberOfChannels: 1,
            encoderSampleRate: 16000,
            encoderFrameSize: 20,
            maxFramesPerPage: 40,
            encoderComplexity: 6,
            encoderApplication: 2048, // Voice
            originalSampleRate: 16000,
            streamPages: true,
            sourceNode: sourceNode
        };

        this.voiceRecorder = new window.Recorder(config);
        this.voiceAudioChunks = [];

        this.voiceRecorder.ondataavailable = (typedArray) => {
            // logger.log(`Data available: ${typedArray.length} bytes`);
            this.voiceAudioChunks.push(typedArray);
        };

        this.voiceRecorder.onstart = () => {
            logger.log('Recording started');
            // status.textContent = 'Recording...';
            // startTime = Date.now();
            // timerInterval = setInterval(updateTimer, 10);
        };

        this.voiceRecorder.onstop = () => {
            logger.log('Recording stopped');
            // status.textContent = 'Processing...';
            // clearInterval(timerInterval);

            // const blob = new Blob(audioChunks, { 'type' : 'audio/ogg; codecs=opus' });
            // audioChunks = []; // Clear the chunks for the next recording
        
            // if (socket && socket.readyState === WebSocket.OPEN) {
            //     log(`Sending audio file: ${blob.size} bytes`);
            //     socket.send(blob);
            // } else {
            //     log('WebSocket is not open. Cannot send audio.');
            // }
            this.dispatchEvent(new AudioServiceEvent(EVENT_VOICEDSUBMIT, this.voiceAudioChunks));
            // this.dispatchEvent({type: EVENT_INITIALIZED, message: this.voiceAudioChunks});
            this.voiceAudioChunks = [];
        };

        console.log(`[AudioService] Recorder Initialized`)
    }

    startRecording() {
        if(!this.voiceRecorder) {
            this.initializeRecorder();
        }
        this.voiceRecorder.start();
    }

    async stopRecording() {
        if(!this.voiceRecorder) {
            return;
        }
        return this.voiceRecorder.stop();
    }
}

let audioService;

export function useAudioService() {
    if(!audioService) {
        audioService = new AudioService();
        audioService.initialize();
    }
    return audioService;
}